import React from "react";
import { Link } from "react-router-dom";

const formatFormType = (type) =>
   type ? type.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()) : "";

const ErrorReportTable = ({ error_reports, onResolve, onUnresolve }) => {
   if (!error_reports || error_reports.length === 0) {
      return (
         <div className="text-center py-5">
            <i className="bi bi-inbox text-muted" style={{ fontSize: "2rem" }}></i>
            <p className="text-muted mt-2">No error reports found</p>
         </div>
      );
   }

   return (
      <div className="table-responsive">
         <table className="table table-hover align-middle">
            <thead className="table-light">
               <tr>
                  <th>Form Type</th>
                  <th>Conversation ID</th>
                  <th>Description</th>
                  <th>Resolution Status</th>
                  <th>Submitted</th>
                  <th>Actions</th>
               </tr>
            </thead>
            <tbody>
               {error_reports.map((report) => (
                  <tr key={report.id}>
                     <td>{formatFormType(report.form_type)}</td>
                     <td>{report.conversation_id}</td>
                     <td>
                        <div className="text-truncate" style={{ maxWidth: "300px" }}>
                           {report.description}
                        </div>
                     </td>
                     <td>
                        {report.resolved === true ? (
                           <span className="badge bg-success">Resolved</span>
                        ) : (
                           <span className="badge bg-danger">Unresolved</span>
                        )}
                     </td>
                     <td>{new Date(report.created_at).toLocaleString()}</td>
                     <td>
                        <div className="d-flex gap-2">
                           <Link
                              to={`/forms/${report.form_id}/errors`}
                              className="btn btn-sm btn-outline-primary"
                              title="View error report details"
                           >
                              <i className="bi bi-eye"></i>
                           </Link>
                           {report.resolved ? (
                              <button
                                 className="btn btn-sm btn-outline-warning"
                                 onClick={() => onUnresolve(report.id)}
                                 title="Mark as unresolved"
                              >
                                 <i className="bi bi-x-circle"></i>
                              </button>
                           ) : (
                              <button
                                 className="btn btn-sm btn-outline-success"
                                 onClick={() => onResolve(report.id)}
                                 title="Mark as resolved"
                              >
                                 <i className="bi bi-check-circle"></i>
                              </button>
                           )}
                        </div>
                     </td>
                  </tr>
               ))}
            </tbody>
         </table>
      </div>
   );
};

export default ErrorReportTable;
